import React from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useLocalAudioOutput } from 'amazon-chime-sdk-component-library-react'
import Fab from '@mui/material/Fab'
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined'
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined'

import ControlBarItem from './ControlBarItem'

type AudioOutputControlProps = { }

export default function AudioOutputControl(props: AudioOutputControlProps) {
  useLingui()
  const { isAudioOn, toggleAudio } = useLocalAudioOutput()

  return (
    <ControlBarItem>
      <Fab color="primary" onClick={toggleAudio} size="small" aria-label={isAudioOn ? t`Mute speaker` : t`Unmute speaker`}>
        {isAudioOn ? <VolumeUpOutlinedIcon /> : <VolumeOffOutlinedIcon />}
      </Fab>
    </ControlBarItem>
  )
}